var monaImagePath = ""

mainApp.service('monaService', [
	    '$http', '$q', 
function($http,   $q ){

	// load the JSON blob

	var deferred = $q.defer(),
		url = ""
	// $http.get('media/json/mona_data.json').then(function (data)
	// $http.get('media/json/download.json').then(function (data)
	// $http.get('http://mona.wgbhdigital.org/data/').then(function (data)

	if (_notlive) {
		url = "http://mona.wgbhdigital.org/data/"
	} else {
		url = 'https://pbs-ingest.s3.amazonaws.com/nova/Making-North-America/activity/data.json'
	}

	 $http.get(url).then(function (data)
	{
		deferred.resolve(data);
	})

	this.getMonaData = function()
	{
		return deferred.promise;
	}
	
}])

mainApp.service('defService', [
	    '$filter',
function($filter){

	// define shared vars and such

	var expireDate = new Date(),
		cookiePrefix = "mna_"

	expireDate.setDate(expireDate.getDate() + 365)

	this.expireDate = function() {return expireDate}
	this.cookiePrefix = function() {return cookiePrefix}

	// ** release dates (determine when to unlock date-release content)

	var now = new Date(),
		locked = {
		"trek" : [false,now < new Date(2015,10,10),now < new Date(2015,10,17)],
		"show" : [now < new Date(2015,10,5),now < new Date(2015,10,12),now < new Date(2015,10,19)],
		"show_date" : ["11/5", "11/12", "11/19"],
		"trek_date" : ["", "11/10", "11/17"],
		"trek_text" : ["","Trek 2 will be available November 10","Trek 3 will be available November 17"]
	}
	if (_notlive) {
		locked = {
		"trek" : [false,false,false],
		"show" : [false,false,false],
		"show_date" : ["11/5", "11/12", "11/19"],
		"trek_date" : ["", "11/10", "11/17"],
		"trek_text" : ["","Trek 2 will be available November 10","Trek 3 will be available November 17"]}			
	}
	// also see app.js

	this.locked = function() {return locked}

	// ** hard-coded gigapans that should be zoomed

	var gigapan_zooms = [
	{"id":99997250, "z":1.1},
	{"id":99930768, "z":1.1},
	{"id":999173941, "z":1.1},
	{"id":99988321, "z":1.4}]

	this.gigapan_zoom = function(gigapan_id) {
	     var found = $filter('filter')(gigapan_zooms, {id: gigapan_id}, true)
	     if (found.length) {
	         return found[0].z
	     } else {
	         return 1
	     }
	 }

}])

mainApp.controller('introController', [
        'monaService', 'defService', '$cookies',
function(monaService ,  defService ,  $cookies){

	var vm = this,
		expire_date = defService.expireDate(),
		cook_name = defService.cookiePrefix() + 'intro95',
		cook = "visited",
		logo = document.getElementById("main-title-shadow"),
		tween_dur = 2,
		tween

		
	vm.title = "Making North America"
	vm.return_user = $cookies.get(cook_name)===cook
	$cookies.put(cook_name, cook, {'expires': expire_date})

	tween_dur = $('#ng-app').hasClass("loaded") ? 0 : 2
	tween = TweenMax.fromTo(logo, tween_dur, {opacity:0}, {opacity:1, repeat:0, delay:3, ease:Linear.easeOut});
	$('#ng-app').addClass("loaded")

	// get all the data from the service
	var promise = monaService.getMonaData();
	promise.then(function (data) {

		vm.alldata = data.data;
		// logit( "All data (in the Intro Controller)" )
		// logit(vm.alldata)
	});  

	// configure Seadragon
	Seadragon.Config.imageLoaderLimit = 6;             // max number of concurrent image downloads
	Seadragon.Config.autoHideControls = false;         // don't hide Seadragon's controls
	Seadragon.Config.imagePath = "lib/seadragon/img/";
	Seadragon.Config.showNavigationControl = true;

	Seadragon.Config.visibilityRatio = 1;
	Seadragon.Config.minZoomImageRatio = 1;

	Seadragon.Config.animationTime = 1.5; // defaiult is 1.5 sec
	Seadragon.Config.springStiffness = 5 // default is 5
	Seadragon.Config.zoomPerClick = 1.5;

}])

mainApp.controller('introVideoController', [
        '$scope', '$state', 
function($scope ,  $state ){

	var vm = this

	vm.video = monaImagePath + $scope.intro.alldata.mona_intro_video

	// check if the video is already initialized!

	var vid = videojs(document.getElementById("underlay_video_intro"), {}, function(){
      	// Player (this) is initialized and ready.
      	this.on('ended',handleVideoEnd);
      	this.src({ type: "video/mp4", src: vm.video });
	}).play()

	// var vid = videojs("underlay_video_intro", {}, function() {
	//     this.on('ended',handleVideoEnd);
	//     this.src({ type: "video/mp4", src: vm.video });
	// }).play()

	function handleVideoEnd() {
		vid.dispose();
		$state.go('home')
	}

	// todo: measure the download speed and handle video stream

}])

mainApp.controller('mapController', [
        '$scope', 'monaService', 
function($scope,   monaService){

	var vm = this,
		i,
		promise = monaService.getMonaData() ,
		BaseIcon = L.Icon.extend({
			options: {
				iconSize: [35, 50],
				iconAnchor: [17, 50],
				popupAnchor: [1, -52],
				shadowSize: [50, 50]
			},
		}),
		northEast = L.latLng(90, -300),
		southWest = L.latLng(-75, 100),
		bounds = L.latLngBounds(northEast, southWest),
		centerlatlong = [50, -112.118808],
		defaultzoom = 3

	// BaseIcon = L.Icon.extend({
	// 	options: {
	// 		iconSize: [25, 41],
	// 		iconAnchor: [12, 41],
	// 		popupAnchor: [1, -46],
	// 		shadowSize: [41, 41]
	// 	},
	// }),

	// centerlatlong ~= Grand Canyon lat (higher), long

	// returns all the data from the service:
	promise.then(function (data) {
		vm.alldata = data.data;
	})

	// ***********************
	// load the map 
	// ***********************

	L.Icon.Default.imagePath = './lib/leaflet-0.7.3/images'

	vm.icon_hover   		= new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon-over.png'})
	vm.icon     			= new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon.png'})
	vm.visited_icon  		= new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon-visited.png'})
	vm.visited_icon_hover   = new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon-visited-over.png'})
	vm.complete_icon  		= new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon-complete.png'})
	vm.complete_icon_hover  = new BaseIcon({iconUrl: L.Icon.Default.imagePath + '/marker-icon-complete-over.png'})
	vm.intmap        		= L.map('map', {maxBounds: bounds}).setView(centerlatlong, defaultzoom)
	vm.showHeader	 		= true
	vm.showBtnProgress	 	= false
	vm.moved         		= false

	vm.intmap.on('movestart', function(e) {
	    //logit("Map moved")
	    if (!vm.moved) {
	    	vm.moved = true
	    	$scope.$apply()
	    }
	})

	//todo: very temp!
	// vm.intmap.on('click', function(e) {
	//     console.log("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng);
	// });

	// // retro!
	// L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}', {
	// 	attribution: 'Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC',
	// 	maxZoom: 16
	// }).addTo(vm.intmap)

	// // watercolor
	// L.tileLayer('http://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png', {
	// 	attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	// 	subdomains: 'abcd',
	// 	minZoom: 1,
	// 	maxZoom: 16,
	// 	ext: 'png'
	// }).addTo(vm.intmap)

	// //nite lite
	// L.tileLayer('http://map1.vis.earthdata.nasa.gov/wmts-webmerc/VIIRS_CityLights_2012/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}', {
	// 	attribution: 'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System (<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
	// 	bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
	// 	minZoom: 1,
	// 	maxZoom: 8,
	// 	format: 'jpg',
	// 	time: '',
	// 	tilematrixset: 'GoogleMapsCompatible_Level'
	// }).addTo(vm.intmap)


	// MapQuest
	// L.tileLayer('http://otile{s}.mqcdn.com/tiles/1.0.0/{type}/{z}/{x}/{y}.{ext}', {
	// 	type: 'sat',
	// 	maxZoom: 18,
	// 	minZoom: 3,
	// 	ext: 'jpg',
	// 	attribution: 'Tiles Courtesy of <a href="http://www.mapquest.com/">MapQuest</a> &mdash; Portions Courtesy NASA/JPL-Caltech and U.S. Depart. of Agriculture, Farm Service Agency',
	// 	subdomains: '1234'
	// }).addTo(vm.intmap)

	// // Tyler's choice: (some zoom levels in greenland a bit fuzzy)
	L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
		attribution: 'Tiles &copy; Esri <span class="mobile-nodisplay">&mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community</span>',
		maxZoom: 18,
		minZoom: 3,
		maxBounds: bounds,
	}).addTo(vm.intmap)

	// // Gigapan option
	// L.tileLayer.gigapan('http://tile155.gigapan.com/gigapans0/155637/tiles/', { 
 //        width: 74088, 
 //        height: 15816,
 //        maxZoom: 5,
 //        minZoom: 1,
 //        tolerance: 0.8,
 //        attribution: 'Photo: Dan Sherman <a href="http://gigapan.com/gigapans/155637" target=_blank>(GigaPan site)</a>'
	// }).addTo(vm.intmap);
	
	// todo: ^^^^^^^^^^^ get a map reference for NOVA instead of personal (only need to do this for MapBox, so probably not necessary now)

	// *************************************************
	// END Load Map
	// *************************************************

	// Map utilities

	vm.clearMarkers = function() {
		if (vm.markers) {
			for (i = 0; i < vm.markers.length; i++) {
				vm.intmap.removeLayer(vm.markers[i])
			}			
		}
		vm.markers = []
    }

    vm.resetMapPosZoom = function() {
    	logit("reset map")
    	if (vm.moved) {
    		vm.intmap.setView(centerlatlong, defaultzoom)
    		vm.moved = false
    	}
    }

}])

mainApp.controller('mapHomeController', [
        '$scope', 
function($scope  ){

	$scope.map.clearMarkers()
	$scope.map.showBtnProgress = false
	$scope.map.resetMapPosZoom()

	var el1 = document.getElementById("beginexplore"),
		el2 = document.getElementById("beginexpedition"),
		el3 = document.getElementById("beginwatch"),
		vh  = document.documentElement.clientHeight - $("#main").offset().top,
		elc = document.getElementById("anim-container")

	// if width > 900 px, set the anim-container height

	if ( document.documentElement.clientWidth > 900 ) {
		elc.style.height = vh + "px"
	} else {
		document.getElementById("anim-container").style.overflow = "visible"
	}

	TweenMax.fromTo(el1, 1.3, {top: vh }, {top:0, repeat:0, delay:1, repeatDelay:0.5, ease: Back.easeOut.config(1.4) });
	TweenMax.fromTo(el2, 1.4, {top: vh }, {top:0, repeat:0, delay:0.5, repeatDelay:0.5, ease: Back.easeOut.config(1.7) });
	TweenMax.fromTo(el3, 1.5, {top: vh }, {top:0, repeat:0, delay:0.1, repeatDelay:0.5, ease: Back.easeOut.config(1.4) });

}])

mainApp.controller('mapExpeditionController', [
        '$scope', 'defService', '$cookies', '$state',
function($scope ,  defService , $cookies,    $state  ){

	var vm = this,
		expire_date = defService.expireDate(),
		cook_name_progress = defService.cookiePrefix() + "progress1"

	vm.progress = $cookies.getObject(cook_name_progress)
	if (!vm.progress) {
		vm.progress = { strandstops: [0,0,0], stopcomplete: [false,false,false], bobs: [0,0,0] }
		$cookies.putObject(cook_name_progress, vm.progress, {'expires': expire_date})		
	}

	// these will be updated when a strand is chosen:

	vm.strand = 0
	vm.stop = 0
	
	$scope.map.showBtnProgress = false
	$scope.map.clearMarkers()

	vm.updateCurrentStrand = function(_strand) {

		// called when you select a new strand

		vm.strand = _strand
		vm.stop = vm.progress.strandstops[vm.strand-1]

		$scope.map.resetMapPosZoom()

		logit("On update, the current strand according to the controller = " + vm.strand)
		logit("On update, the highest stop for this strand according to the cookie = " + vm.stop)
	}

	vm.updateProgressCookie = function() {

		logit("update expedition progress cookie on completion of stop")

		vm.stop++
		if (vm.stop > 4) {
			vm.stop = 5
			vm.progress.stopcomplete[vm.strand-1] = true
			if(vm.strand==3) {
				logit("congrats, you are done")
			}
		}
		vm.progress.strandstops[vm.strand-1] = vm.stop
		$cookies.putObject(cook_name_progress, vm.progress, {'expires': expire_date})
	}

	vm.updateBobbleFoundCookie = function() {

		//logit("store Bobble cookie")
		vm.progress.bobs[vm.strand-1] = 1
		$cookies.putObject(cook_name_progress, vm.progress, {'expires': expire_date})
	}

	vm.isTrekBobbleNeeded = function(i) {

		// returns true only if Trek is done and Bobble is not done
		return vm.progress.stopcomplete[i] && vm.progress.bobs[i]===0
	}

	vm.isTrekComplete = function(i) {

		// returns true if strand is complete (all locations complete)
		return vm.progress.stopcomplete[i]
	}

	vm.isExpeditionComplete = function() {
		var done = true,
			i

		for (i = 0; i < vm.progress.stopcomplete.length; i++) {
			if (!vm.progress.stopcomplete[i]) {
				done = false
			}
		}

		return done
	}

	vm.isBobComplete = function() {
		var done = true,
			i

		for (i = 0; i < vm.progress.bobs.length; i++) {
			if (vm.progress.bobs[i]===0) {
				done = false
			}
		}

		return done
	}

	vm.resetAll = function() {

		logit("resetAll")

		var cook_name

		vm.progress = { strandstops: [0,0,0], stopcomplete: [false,false,false], bobs: [0,0,0] }
		$cookies.putObject(cook_name_progress, vm.progress, {'expires': expire_date})

		cook_name = defService.cookiePrefix() + 'intro95'	
		$cookies.put(cook_name, "", {'expires': expire_date})

		cook_name = defService.cookiePrefix() + "explore"
		$cookies.put(cook_name, "", {'expires': expire_date})

		$state.go('intro') 

	}

}])

mainApp.controller('mapExpeditionMenuController', [
        '$scope', 'defService',
function($scope ,  defService ){

	var vm = this

	logit("The Expie menu highest strand according to the cookie = " + $scope.expedition.strand)
	logit("The Expie menu highest stop for this strand according to the cookie = " + $scope.expedition.stop)

	vm.locked = defService.locked()

	logit(vm.locked)

}])


mainApp.controller('mapExpeditionStrandController', [
        '$scope', '$stateParams', '$state', 
function($scope ,  $stateParams ,  $state ){

	var vm = this, 
		i = 0,
		x, y,
		thisIcon,
		locName,
		locFormattedName

	if( !$scope.map.alldata) {return}

	vm.bobble_images = [
		"./media/img/bobblegif-gooseberry.gif",
		"./media/img/bobblegif-tarpit.gif",
		"./media/img/bobblegif-bodie.gif"
	]

	vm.strand = $stateParams.strand
	vm.strand_loc_slugs = $scope.map.alldata.strands[vm.strand-1].locations
	vm.bobblehead_feedback = $scope.map.alldata.strands[vm.strand-1].bobblehead_gigapan_feedback
	vm.bobble_img = vm.bobble_images[vm.strand-1]
	logit("The bobble image in js = " + vm.bobble_img)
	vm.locations = $scope.map.alldata.locations
	vm.found = false
	vm.showIntroVideo = false
	vm.info_hide = false
	vm.showexplainervid = false
	$scope.expedition.updateCurrentStrand(vm.strand)
	$scope.map.showBtnProgress = $scope.expedition.isTrekComplete(vm.strand-1)
	loadStop()
	initMarkers()
	vm.video = monaImagePath + $scope.map.alldata.strands[vm.strand-1].video_id

	if ($scope.expedition.progress.strandstops[vm.strand-1]===0) {

		var vid = videojs(document.getElementById("underlay_video_trek_intro"), {}, function(){
	      	this.on('ended',handleVideoEnd);
	      	this.src({ type: "video/mp4", src: vm.video });
		}).play()
		vm.showIntroVideo = true	
		$scope.map.showHeader = false	
	}

	function handleVideoEnd() {
		vm.stopIntroVideo()
		$scope.$apply()
	}

	vm.stopIntroVideo = function() {
		vm.showIntroVideo = false
		$scope.map.showHeader = true
		vid.dispose()
	}

	vm.loadStop = function() {
		logit("load a stop")
		for (i = 0; i < $scope.map.markers.length; i++) {
			$scope.map.markers[i].closePopup()
			$scope.map.markers[i].setIcon(fetchIcon($scope.map.markers[i].options.idx))
		}
		loadStop()
	}

	function loadStop() {

		// loads the clue and sets the marker popups

		vm.info_hide = false
		vm.found = false
		vm.showClue = true
		vm.stopdata = vm.locations[vm.strand_loc_slugs[$scope.expedition.stop]]
	}

	function fetchIcon(idx) {
		return idx >= $scope.expedition.progress.strandstops[vm.strand-1] ? $scope.map.icon : $scope.map.complete_icon
	}	

	function fetchIconHover(idx) {
		return idx >= $scope.expedition.progress.strandstops[vm.strand-1] ? $scope.map.icon_hover : $scope.map.complete_icon_hover
	}	

	function initMarkers() {

		// *** Expedition ***
		// this constructs the map markers and adds events to them
		// it's done once when the controller is started up

		logit("initMarkers()")

		$scope.map.clearMarkers()

		for (i = 0; i < vm.strand_loc_slugs.length; i++) {

			x = vm.locations[vm.strand_loc_slugs[i]].x
			y = vm.locations[vm.strand_loc_slugs[i]].y

			locName = vm.locations[vm.strand_loc_slugs[i]].name

			locFormattedName = locName.split(',')[1] !== "" ? locName.split(',')[0] + "<br />" + locName.split(',')[1] : locName

			if (x && y) {
				thisIcon = fetchIcon(i)
				$scope.map.markers.push( L.marker([x, y],{slug: vm.strand_loc_slugs[i], idx: i, name: locFormattedName, icon: thisIcon})
				.addTo($scope.map.intmap) 
				.bindPopup(locFormattedName,{closeButton: false, closeOnClick: false, minWidth: 100, maxWidth: 300 })		
				.on('click', onClick)
				.on('mouseover', onMouseOver)
				.on('mouseout', onMouseOut)
				)	
			}
		}
	}
	function onMouseOver(e) {
		this.setIcon(fetchIconHover(this.options.idx))
		if (vm.found && this.options.idx===$scope.expedition.stop) {
			// don't reset the content
		} else {
			this.setPopupContent(this.options.name)
		}
		this.openPopup()
	}
	function onMouseOut(e) {
		this.setIcon(fetchIcon(this.options.idx))
		if (vm.found && this.options.idx===$scope.expedition.stop) {
			return
		}
		this.closePopup()
	}
	function loadExpStop() {
		logit("done")
	}
	function onClick(e) {
		if (this.options.idx < $scope.expedition.stop) {
			// this.setPopupContent("You've been here already.")
			this.setPopupContent("")

			$state.go('expstop', {expstop:this.options.idx})	

		} else if (this.options.idx != $scope.expedition.stop) {
			this.setPopupContent("Not here–try again")
		} else if (!vm.found) {
			vm.found = true
			$scope.$apply()
			//this.setPopupContent(this.options.name + "<br>Yes!<br><button onClick='loadExpStop()'>GO</button>")
			// todo: this is a bit manual:
			logit("The expedition stop = " + $scope.expedition.stop)
			switch($scope.expedition.stop) {
				case 0:
					this.setPopupContent(expStop0)
					break;
				case 1:
					this.setPopupContent(expStop1)
					break;
				case 2:
					this.setPopupContent(expStop2)
					break;
				case 3:
					this.setPopupContent(expStop3)
					break;
				case 4:
					this.setPopupContent(expStop4)
					break;
				default:
					break;
			}
		}
		this.openPopup()
	}
	$scope.$on("$destroy", function() {
		logit("destroy the expedition strand controller")
		//todo: need a way to check if the video player has been disposed, cuz disposing a dead player throws an error
		// if (vid {
		// 	vid.dispose()
		// }
    })

}])

mainApp.controller('mapExpeditionStrandStopController', [
        '$scope', '$stateParams', '$sce', 'defService',
function($scope ,  $stateParams ,  $sce ,  defService ){

	var vm = this

	vm.showintro = false
	vm.showgig = false
	vm.showexplainer = false
	vm.showvid = $scope.strand.showexplainervid = false
	vm.strand = $scope.strand.strand
	vm.id = $stateParams.expstop
	vm.showhint = false
	vm.monaImagePath = monaImagePath
	vm.showbobble = false
	vm.showtutorial = false
	vm.repeat = false



	$scope.map.showHeader = false

	// already have the stop loaded in the parent controller
	// can just get this since the repeat needs info, too
	// vm.data = $scope.strand.stopdata.expedition[0]

	vm.strand_loc_slugs = $scope.map.alldata.strands[vm.strand-1].locations
	vm.locations = $scope.map.alldata.locations
	vm.data = vm.locations[vm.strand_loc_slugs[vm.id]].expedition[0]
	vm.explainer_video = vm.monaImagePath + vm.data.explainer_video

	initStop()

	function initStop() {
		vm.repeat = (vm.id!=$scope.expedition.stop)
		vm.showintro = !vm.repeat // true
		vm.showgig = vm.repeat // false
		vm.showexplainer = false
		vm.showvid = $scope.strand.showexplainervid = false
		vm.showhint = false
		vm.showtutorial = false
		vm.showgoal = false
	}

	// *****************************************
	// START of tutorial slider code
	// *****************************************

	vm.slides = [
		{content:"Click, drag, and zoom around this panoramic image to find the hidden artifact described in the tab above."},
		{content:"You can use the buttons below to help navigate the image. Click on the artifact when you find it."},
		{content:"Click on “?” in the tab above to get a smaller area to search inside. "},
		{content:"P.S. There is a bonus object hidden in one of the five locations in each trek."},
		{content:"P.P.S. Here's the first artifact that you will find. <br><img class='slide-tutorial-preview' src='" + vm.monaImagePath + vm.data.success_image + "' alt='first hidden object' />", disclaimer:"The artifacts and bonus objects you’ll be collecting<br>were not literally discovered in these precise locations."}
	]

	vm.highest_level = vm.slides.length - 1
	vm.slide_index = 0
	vm.slide_direction = 'left'

	logit("The slides highest = " + vm.highest_level)

	vm.slideAdvance = function (iDir) {
	    logit("advance the slider by " + iDir)

	    if ( iDir < 0 ) {
	        //prev
	        vm.slide_index = (vm.slide_index > 0) ? --vm.slide_index : vm.slide_index 
	        vm.slide_direction = 'right';
	    } else {
	        //next (use the highest level; dom elements for higher level panels exist but we never want to see them for this level)
	        vm.slide_index = (vm.slide_index < vm.highest_level) ? ++vm.slide_index : vm.slide_index           
	        vm.slide_direction = 'left';
	    }
	    logit("slideAdvance, vm.slide_index = " + vm.slide_index)
	
	}

	vm.setCurrentSlideIndex = function (index) {
	    logit("The setCurrentSlideIndex index = " + index)
	    vm.slide_direction = (vm.slide_index < index) ? 'left' : 'right'
	    vm.slide_index = index
	};

	vm.isCurrentSlideIndex = function (index) {
	    return vm.slide_index === index;
	};

	// *****************************************
	// END of tutorialslider code
	// *****************************************



	function firstStop() {
		var i, first = true
		for (i = 0; i < $scope.expedition.progress.strandstops.length; i++) {
			if ( $scope.expedition.progress.strandstops[i] > 0 ) {
				first = false
			}
		}
		return first
	}

	vm.loadGoal = function() {
		// todo: jiggle / bounce the goal onto the screen
		vm.showgoal=true
	}

	vm.handleIntroNext = function() {
		vm.showintro=false	
		vm.showgig=true		
		vm.loadGoal()
		if (firstStop()) {
			vm.showtutorial = true;
		}
	}

	vm.handleTutorialNext =function() {
		vm.showtutorial = false
		vm.showgig=true
		vm.loadGoal()
	}

	vm.playVideo = function() {

		vm.endMedia()
		vm.showvid = $scope.strand.showexplainervid = true

		var vid = videojs(document.getElementById("underlay_video"), {}, function(){
	      	// Player (this) is initialized and ready.
	      	this.on('ended',function() {
	      		// vid.dispose();
	      		// rewind and pause if necessary
	      	});
	      	this.src({ type: "video/mp4", src: vm.explainer_video });  
		}).play()
	}

	vm.playGigapan = function(index) {
		vm.endMedia()
		//vm.showgig = true

		if (gigapan.id != vm.data.gigapan[index].id) {

			gigapan.id = vm.data.gigapan[index].id
			gigapan.width = Number(vm.data.gigapan[index].width)
			gigapan.height = Number(vm.data.gigapan[index].height)
			gigapan.caption = vm.data.gigapan[index].caption
			wgp = gigapan.width
			hgp = gigapan.height
			zoom_init = defService.gigapan_zoom(gigapan.id)
			zoom = zoom_init * hv * wgp / (wv * hgp)
			pointofinterest = new Seadragon.Point( 0.5 , 0.5 * gigapan.height / gigapan.width )
			loadGigapan()
		}
	}

	vm.endMedia = function() {
	  vm.showgig = false
	  vm.showvid = $scope.strand.showexplainervid = false
	  vm.showexplainer = false
	  viewer.close()
	}

    // *****************************************
    // Start of Gigapan integration
    // *****************************************

    var SeadragonUtils = org.gigapan.seadragon.SeadragonUtils,
    	touchManager = new org.cmucreatelab.multitouch.TouchManager(),
    	pinchMidpoint = null,
    	viewer = null,
    	isFound = false,
    	gigapan = {
         "id" : 0,
         "authKey" : null,
         "width" : 0,
         "height" : 0
      },
    	wgp = gigapan.width,
    	hgp = gigapan.height,
    	wv  = document.documentElement.clientWidth, 
    	hv  = document.documentElement.clientHeight, 
    	zoom_init = 1,
    	zoom = zoom_init * hv * wgp / (wv * hgp),
    	initialViewBoundsRect = new Seadragon.Rect(0.5, 0.25, 1.0, 0.5),
    	pointofinterest = new Seadragon.Point( 0.5 , 0.5 * gigapan.height / gigapan.width ),
    	hintBoundsDisplay = new Seadragon.Rect( 
					  0,
					  0,
					  100,
					  50 )

    // register event handlers with the TouchManager
    touchManager.addEventListener('tap', tapEventHandler);
    touchManager.addEventListener('pan', panEventHandler);
    touchManager.addEventListener('pinch-start', pinchStartEventHandler);
    touchManager.addEventListener('pinch', pinchEventHandler);

	// create and initialize the viewer
	viewer = new Seadragon.Viewer("gigapan_viewer");
	viewer.setDashboardEnabled(true);
	viewer.addEventListener("open", handleViewerOpen);

	// disable click to zoom
	//viewer.tracker.clickHandler = null;

	window.addEventListener("resize", resizeCanvas, false);

	function loadGigapan() {
	   // clear the viewer
	   viewer.close();
	   window.setTimeout(function() {
	      // create the tile source
	      var tileSource = new org.gigapan.seadragon.GigapanTileSource(
	            org.gigapan.GigapanUtils.createTileSourceUrlPrefixForGigapan(gigapan.id, null),
	            gigapan.width,
	            gigapan.height
	      );
	      // tell the viewer to open the tile source
	      viewer.openTileSource(tileSource);
	   }, 1);
	}
	function handleViewerOpen() {
	   // set the initial viewport bounds, set the optional "immediately" param to true so that there's no zoom animation
	   viewer.viewport.zoomTo(zoom, pointofinterest, true)

	   // if rect -> do rect
	   // if point -> do point
	   // if find -> make clickable, etc

	   logit("The bobs are ")
	   logit($scope.expedition.progress.bobs)


	    var i,
	   		clickBounds,
	   		clickOverlay, 
	   		touchSensitiveElement = viewer.drawer.elmt

	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchstart", touchManager.onTouchStart)
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchmove", touchManager.onTouchMove)
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchend", touchManager.onTouchEndOrCancel)
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchcancel", touchManager.onTouchEndOrCancel)



	   	for (i = 0; i < vm.data.map_object.length; i++) {
	   		var o = vm.data.map_object[i]
	   		if (o.use === "find" && !vm.repeat) {
   			   	clickBounds = new Seadragon.Rect( 
   			   	  o.position_x,
   			   	  o.position_y,
   			   	  o.width,
   			   	  o.height)

   			    clickOverlay = $('<div class="trans_overlay"><img src="'+monaImagePath+o.image+'" /></div>');
   			    viewer.drawer.addOverlay(clickOverlay.get(0), clickBounds);
   			    clickOverlay.click(handleOverlayClick)
   			    

	   		} else if (o.use === "bobl" && $scope.expedition.progress.bobs[vm.strand-1]===0) {
   			   	clickBounds = new Seadragon.Rect( 
   			   	  o.position_x,
   			   	  o.position_y,
   			   	  o.width,
   			   	  o.height)

   			    clickOverlay = $('<div class="trans_overlay bobblehead"><img src="'+monaImagePath+o.image+'" /></div>');
   			    viewer.drawer.addOverlay(clickOverlay.get(0), clickBounds);
   			    clickOverlay.click(handleBobbleClick)

	   		} else if (o.use === "hint" && !vm.repeat) {
	   			// create a hint button and add the overlay
	   			var hintOverlay,
	   				hintBounds
	   			if (o.type === "point") {
	   				// still allow a point overlay, since impossible to make css div in  this case
	   				hintOverlay = $('<div class="hint_overlay"><img src="'+monaImagePath+o.image+'" /></div>');
	   				hintBounds = new Seadragon.Point(
	   				  o.position_x,
	   				  o.position_y)
	   				viewer.drawer.addOverlay(hintOverlay.get(0), hintBounds, Seadragon.OverlayPlacement.TOP_LEFT)
	   			} else if (o.type === "rectangle") {
	   				// updated 8/10/15 to ignore image (in preparation for using css box)
	   				// hintOverlay = $('<div class="hint_overlay"><div class="instructions">Search Here</div><div class="hint-box"></div></div>');
	   				hintOverlay = $('<div class="hint_overlay"></div>');
	   				hintBounds = new Seadragon.Rect( 
	   				  o.position_x,
	   				  o.position_y,
	   				  o.width,
	   				  o.height)
	   				hintBoundsDisplay = new Seadragon.Rect( 
	   				  o.position_x - 0.3 * o.width,
	   				  o.position_y,
	   				  1.6 * o.width,
	   				  o.height)
	   				viewer.drawer.addOverlay(hintOverlay.get(0), hintBounds)
	   			}
	   			vm.showhint=true
	   			$scope.$apply()

	   		} else if (o.use === "info") {
	   			var infoBounds
	   			if (o.type === "point") {
	   				infoOverlay = $('<div class="info_overlay point"><img src="'+monaImagePath+o.image+'" /></div>')
	   				infoBounds = new Seadragon.Point(
	   				  o.position_x,
	   				  o.position_y)
	   				viewer.drawer.addOverlay(infoOverlay.get(0), infoBounds, Seadragon.OverlayPlacement.TOP_LEFT);

	   			} else if (o.type === "rectangle") {
	   				infoOverlay = $('<div class="info_overlay rectangle"><img src="'+monaImagePath+o.image+'" /></div>')
	   				infoBounds = new Seadragon.Rect( 
	   				  o.position_x,
	   				  o.position_y,
	   				  o.width,
	   				  o.height)
	   				viewer.drawer.addOverlay(infoOverlay.get(0), infoBounds);
	   			}
	   		}

	   	}

	}
   	function handleOverlayClick() {
	   	if (!isFound &&                           // if we still haven't found him
	   	    viewer.isOpen() &&                    // if the viewer is open
	   	    viewer.viewport ){                     // if the viewport is defined
	   	    //viewer.viewport.getZoom() >= 6) {    // if the image is sufficiently zoomed in
	   	    isFound = true;
	   	    foundFinished()
	   	}
   	}
   	function handleBobbleClick() {
   		// show a Bobble congrats first time you click on it
   		logit("Found Bobble")
   		vm.showbobble = true
   		$scope.$apply()
   		$scope.expedition.updateBobbleFoundCookie()
   		$('.trans_overlay.bobblehead').hide(300) // a little jquery
   	}
	function handleInterestPointSelection(interestPoint) {
	   if (interestPoint) {
	      // zoom to the interest point's view bounds
	      viewer.viewport.fitBounds(interestPoint.zoomRect);
	      // display the interest point media panel
	      $("#media_panel_title").text(interestPoint.mediaPanel.title);
	      $("#media_panel_description").text(interestPoint.mediaPanel.description);
	      $("#media_panel").show();
	   }
	}
	function tapEventHandler(touchPoint, elapsedTouchTime, event) {
		// I would only use this to identify a touch on one of the find objects

		


	   if (viewer.isOpen() && viewer.viewport) {
	   	
	      // See whether this was a tap on an interest point
	      if (typeof event === 'object' && event.currentTarget) {

	      

	      	
	   	
	         var targetElement = $(event.target.parentNode);

	         //alert(targetElement.get(0).className)




	         if (targetElement.length > 0 && targetElement.hasClass("bobblehead")) {
	         	
	         	handleBobbleClick()


	         } else if (targetElement.length > 0 && targetElement.hasClass("trans_overlay")) {
	         	
	         	handleOverlayClick()

	         }
	      }
	   }
	}

	function panEventHandler(pixelDeltaFromPrevious, event) {
		//alert("panEventHandler")
	    if (viewer.isOpen() && viewer.viewport) {
	      	var panBy = viewer.viewport.deltaPointsFromPixels(pixelDeltaFromPrevious);
	      	viewer.viewport.panBy(panBy);
	    }
	}
	function pinchStartEventHandler(touch1, touch2, midpoint, event) {
		//alert("pinchStartEventHandler")
	    if (viewer.isOpen() && viewer.viewport && midpoint !== null) {
	      	// record the current midpoint in Seadragon coords so all future pinch events during this
	      	// pinch will zoom about this point
	      	pinchMidpoint = SeadragonUtils.convertPageCoordsToSeadragonCoords(midpoint.toSeadragonPoint(), viewer);
	    }
	}
	function pinchEventHandler(scaleDeltaX, scaleDeltaY, scaleDeltaXY, touch1, touch2, event) {
		//alert("pinchEventHandler")
	    // clamp the zoom scale delta to within [0.8, 1.2]
	    scaleDeltaXY = Math.max(0.8, Math.min(1.2, scaleDeltaXY));
	    if (viewer.isOpen() && viewer.viewport && pinchMidpoint !== null) {
	      	viewer.viewport.zoomBy(scaleDeltaXY, pinchMidpoint);
	      	// clamp the zoom level to [viewer.viewport.getMinZoom(), viewer.viewport.getMaxZoom()]
	      	if (viewer.viewport.getZoom() > viewer.viewport.getMaxZoom()) {
	         	viewer.viewport.zoomTo(viewer.viewport.getMaxZoom(), pinchMidpoint);
	      	}
	      	else if (viewer.viewport.getZoom() < viewer.viewport.getMinZoom()) {
	         	viewer.viewport.zoomTo(viewer.viewport.getMinZoom(), pinchMidpoint);
	      	}
	   	}
	}


	function resizeCanvas (e) {

		// todo: record current giga Point and size around that

		// var p = new Seadragon.Point( viewer.viewport.getHomeCenter() )
		// console.log("The center point before resize = " + p)

		// todo: this should be smoother (doesn't seem to align with top of the window)

		if (viewer.isOpen() && viewer.viewport) {
			wv  = document.documentElement.clientWidth
			hv  = document.documentElement.clientHeight
			zoom = zoom_init * hv * wgp / (wv * hgp)
			viewer.viewport.zoomTo(zoom, pointofinterest, true)
		}
	}

	vm.showHint = function() {
		//logit("show the hint, dude")
		$('.hint_overlay').addClass("showhint")
		if (viewer) {
			viewer.viewport.fitBounds(hintBoundsDisplay);
		}
	}

	// *************************************************
	// END Gigapan integration
	// *************************************************

	// todo: this is a little weird to have to call this at the bottom of the function
	vm.playGigapan(0)
	vm.showgig = vm.repeat // false

	// *****************************************
	// Start of Gigapan overlay from CMS
	// *****************************************

	function foundFinished() {

		logit("found finished")

		isFound = false
		vm.showsuccess = true
		$('.hint_overlay').removeClass("showhint")
		$scope.$apply()
	}

	vm.successFinished = function() {

		logit("successFinished, play video and show info, vidurl = " + vm.explainer_video)

		vm.showvid = $scope.strand.showexplainervid = true
		vm.showgig = vm.showsuccess = false
		vm.playVideo()

		$scope.expedition.updateProgressCookie()
	}

	$scope.$on("$destroy", function() {
		logit("destroy the expedition strand stop controller")
	    videojs("underlay_video").dispose()
	    $scope.map.showHeader = true
	    $scope.strand.showexplainervid = false
    })

}])

mainApp.controller('mapExpeditionProgressController', [ '$scope', 'defService', '$cookies', '$sce',

function($scope, defService, $cookies, $sce ){

	var vm = this,
		i, j, k, o

	vm.progressdeck = []
	vm.monaImagePath = monaImagePath
    vm.bobfound = $scope.expedition.progress.bobs[$scope.expedition.strand-1]===1
    vm.locked = defService.locked()

	// get the current strand progress
	// get the bobblehead progress
	// use these two progresses for the view
	// todo: handle the bobblehead found/ not found states for each strand

	// construct the data structure, since it is a mix of values from alldata

	vm.locations = $scope.map.alldata.locations

	for (j = 0; j < $scope.map.alldata.strands.length; j++) {

		vm.strand_loc_slugs = $scope.map.alldata.strands[j].locations
		var trekdeck = []

		for (i = 0; i < vm.strand_loc_slugs.length; i++) {

			var singlecard = {}

			singlecard.title       = vm.locations[vm.strand_loc_slugs[i]].expedition[0].progress_card_title
			singlecard.description = vm.locations[vm.strand_loc_slugs[i]].expedition[0].progress_card_description
			singlecard.age         = vm.locations[vm.strand_loc_slugs[i]].expedition[0].progress_card_age
			singlecard.image       = vm.monaImagePath + vm.locations[vm.strand_loc_slugs[i]].expedition[0].success_image
			singlecard.date        = ""

			o = vm.locations[vm.strand_loc_slugs[i]].expedition[0].map_object

			for (k = 0; k < o.length; k++) {
				if (o[k].use==="find") {
					singlecard.date = o[k].date
				}
			}

			// pack card
			trekdeck.push(singlecard)
		}

		// pack deck
		vm.progressdeck.push(trekdeck)
	}

	logit("vm.progressdeck = ")
	logit(vm.progressdeck)

}])

mainApp.controller('mapExploreController', [ '$scope', '$state', 'defService', '$cookies', '$sce',
         
function($scope, $state, defService, $cookies, $sce ){

	var vm = this,
		i,
		x,
		y,
		show_on_explore_map,
		attrName,
		attrValue,
		locFormattedName,
		expire_date = defService.expireDate(),
		cook_name = defService.cookiePrefix() + "explore",
		cook = $cookies.getObject(cook_name),
		thisIcon,
		_slug



	vm.monaImagePath = monaImagePath
	vm.locations = $scope.map.alldata.locations
	vm.tour = {
		"title": "Explore",
		"cove_id": 2365302438,
		"caption": "Click on the map pins to explore spectacular geological sites across North America. You can also see highlights on our video sky tour."
	}
	vm.showvid = false
	vm.cove_iframe = false
	vm.playVideo = function(cove_id) {
		tween.pause()
		vm.showvid = true
		$scope.map.showHeader = false
		vm.cove_iframe = $sce.trustAsHtml( constructVideoDiv(cove_id, true, 2*1080, 2*608) )
	}
	vm.endMedia = function() {
		logit("close me")
	 	vm.showvid = false
	 	$scope.map.showHeader = true
	 	vm.cove_iframe = "" // kill the video
	 	tween.play()
	}

	if (!cook) {
		cook = []
		$cookies.putObject(cook_name, cook, {'expires': expire_date})
	}

	initMarkers()

	function initMarkers() {

		// Explore

		// this is going to construct the map markers and add events to them
		// it's done once when the controller is started up
		// history is stored in cookies

		$scope.map.clearMarkers()

		logit(vm.locations)

		for (var key in vm.locations) {
			if ( vm.locations.hasOwnProperty(key) ) {
				attrName = key
				attrValue = vm.locations[key]
				x = attrValue.x
				y = attrValue.y
				show_on_explore_map = attrValue.show_on_explore_map
				locFormattedName = attrValue.name.split(',')[1] !== "" ? attrValue.name.split(',')[0] + "<br />" + attrValue.name.split(',')[1] : attrValue.name

				if (x && y && show_on_explore_map) {
					thisIcon = cook.indexOf(attrName) === -1 ? $scope.map.icon : $scope.map.visited_icon
					$scope.map.markers.push( L.marker([x, y],{slug: attrName, icon: thisIcon})
					.addTo($scope.map.intmap) 
					.bindPopup(locFormattedName,{closeButton: false, closeOnClick: false, minWidth: 100, maxWidth: 300 })	
					.on('click', onClick)
					.on('mouseover', onMouseOver)
					.on('mouseout', onMouseOut)
					)
				}
			}
		}
	}

	function onMouseOver(e) {
		if (cook.indexOf(this.options.slug) === -1) {
			this.setIcon($scope.map.icon_hover)
		} else {
			this.setIcon($scope.map.visited_icon_hover)
		}
		this.openPopup()
	}	
	function onMouseOut(e) {
		if (cook.indexOf(this.options.slug) === -1) {
			this.setIcon($scope.map.icon)
		} else {
			this.setIcon($scope.map.visited_icon)
		}
		this.closePopup()
	}
	function onClick(e) {
		this.setIcon($scope.map.visited_icon)
		_slug = this.options.slug
		if (_slug) {
			if (cook.indexOf(_slug) === -1) {
				cook.push(_slug)
				$cookies.putObject(cook_name, cook, {'expires': expire_date})							
			}
			$state.go('location', {slug:_slug})			
		}
	}
	$scope.clearExploreCookies = function() {
		cook = []
		$cookies.putObject(cook_name, cook, {'expires': expire_date})
		$scope.map.clearMarkers()
		initMarkers()
	}

	var wv, wh, tween, sat = document.getElementById("tour-button-container-abs"), sat_static = document.getElementById("tour-button-container")

	vm.startSatellite = function() {

		wv  = document.documentElement.clientWidth - 100
		wh  = 0.72 * document.documentElement.clientHeight 

		tween = TweenMax.fromTo(sat, 40, {left:wv, top: '100px' }, {left:"35px", top:wh-100, repeat:0, onComplete:onComplete, repeatDelay:0.5, ease:Linear.easeNone});
	}

	vm.startSatellite()

	function onComplete() {
		logit("complete sat")

		// if window was resized, restart animation

		// wv  = document.documentElement.clientWidth
		// TweenMax.set(sat, {left:wv}

		// set vis to satelitte = 0
		// turn on other button vis in the explore box

		sat_static.style.visibility = 'visible';
		sat.style.visibility = 'hidden';
		//TweenMax.fromTo(sat_static, 1, {opacity:0}, {opacity:1})

	}

	vm.stopSatellite = function() {
		
	}


	$scope.$on("$destroy", function() {
		logit("destroy the explore controller")
		vm.cove_iframe = ""
    })

}])

mainApp.controller('mapExploreLocationController', [
	    '$stateParams', '$scope', '$sce', 'defService',
function($stateParams ,  $scope ,  $sce ,  defService ){

	var vm = this

	vm.showgig = false
	vm.showvid = false
	vm.cove_iframe = ""
	vm.slug = $stateParams.slug
	if (vm.slug) {
		vm.data = $scope.map.alldata.locations[vm.slug]
		// logit("Location data: ")
		// logit(vm.data)
	}

	$scope.map.showHeader = false

	vm.playVideo = function(cove_id) {

		//todo: should this be a directive?

		// best solution may be to overlay a video, ala evolution:
		vm.endMedia()
		vm.showvid = true
		vm.cove_iframe = $sce.trustAsHtml( constructVideoDiv(cove_id, true, 2*1080, 2*608) )
	}

	vm.playGigapan = function(index) {
		vm.endMedia()
		vm.showgig = true

		if (gigapan.id != vm.data.gigapan[index].id) {

			gigapan.id = vm.data.gigapan[index].id
			gigapan.width = Number(vm.data.gigapan[index].width)
			gigapan.height = Number(vm.data.gigapan[index].height)
			gigapan.caption = vm.data.gigapan[index].caption
			wgp = gigapan.width
			hgp = gigapan.height
			zoom_init = defService.gigapan_zoom(gigapan.id)
			zoom = zoom_init * hv * wgp / (wv * hgp)
			pointofinterest = new Seadragon.Point( 0.5 , 0.5 * gigapan.height / gigapan.width )
			loadGigapan()
		}
	}

	vm.endMedia = function() {
	  vm.showgig = false
	  vm.showvid = false
	  vm.cove_iframe = "" // kill the video
	  //viewer.close()
	}

	$scope.$on("$destroy", function() {
		logit("destroy the location controller")
		window.removeEventListener("resize", resizeCanvas);
		viewer.close()
		$scope.map.showHeader = true
    });

    // *****************************************
    // Start of Gigapan integration
    // *****************************************

    // todo: can this be in a Directive - it looks pretty self-contained

    var SeadragonUtils = org.gigapan.seadragon.SeadragonUtils,
    	touchManager = new org.cmucreatelab.multitouch.TouchManager(),
    	pinchMidpoint = null,
    	viewer = null,
    	gigapan = {
         "id" : 0,
         "authKey" : null,
         "width" : 0,
         "height" : 0
      },
    	wgp = gigapan.width,
    	hgp = gigapan.height,
    	wv  = document.documentElement.clientWidth, 
    	hv  = document.documentElement.clientHeight, 
    	zoom_init = 1,
    	zoom = zoom_init * hv * wgp / (wv * hgp),
    	initialViewBoundsRect = new Seadragon.Rect(0.5, 0.25, 1.0, 0.5),
    	pointofinterest = new Seadragon.Point( 0.5 , 0.5 * gigapan.height / gigapan.width )

    // register event handlers with the TouchManager
    //touchManager.addEventListener('tap', tapEventHandler);
    touchManager.addEventListener('pan', panEventHandler);
    touchManager.addEventListener('pinch-start', pinchStartEventHandler);
    touchManager.addEventListener('pinch', pinchEventHandler);

	// create and initialize the viewer
	viewer = new Seadragon.Viewer("gigapan_viewer");
	viewer.setDashboardEnabled(true);
	viewer.addEventListener("open", handleViewerOpen);
	// disable click to zoom
	//viewer.tracker.clickHandler = null;

	window.addEventListener("resize", resizeCanvas, false);

	function loadGigapan() {
	   // clear the viewer
	   viewer.close();
	   window.setTimeout(function() {
	      // create the tile source
	      var tileSource = new org.gigapan.seadragon.GigapanTileSource(
	            org.gigapan.GigapanUtils.createTileSourceUrlPrefixForGigapan(gigapan.id, null),
	            gigapan.width,
	            gigapan.height
	      );
	      // tell the viewer to open the tile source
	      viewer.openTileSource(tileSource);
	   }, 1);
	}
	function handleViewerOpen() {
	   // set the initial viewport bounds, set the optional "immediately" param to true so that there's no zoom animation
	   viewer.viewport.zoomTo(zoom, pointofinterest, true)

	   var touchSensitiveElement = viewer.drawer.elmt;
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchstart", touchManager.onTouchStart);
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchmove", touchManager.onTouchMove);
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchend", touchManager.onTouchEndOrCancel);
	   Seadragon.Utils.addEvent(touchSensitiveElement, "touchcancel", touchManager.onTouchEndOrCancel);
	}
	function panEventHandler(pixelDeltaFromPrevious, event) {
		//alert("panEventHandler")
	    if (viewer.isOpen() && viewer.viewport) {
	      	var panBy = viewer.viewport.deltaPointsFromPixels(pixelDeltaFromPrevious);
	      	viewer.viewport.panBy(panBy);
	    }
	}
	function pinchStartEventHandler(touch1, touch2, midpoint, event) {
		//alert("pinchStartEventHandler")
	    if (viewer.isOpen() && viewer.viewport && midpoint !== null) {
	      	// record the current midpoint in Seadragon coords so all future pinch events during this
	      	// pinch will zoom about this point
	      	pinchMidpoint = SeadragonUtils.convertPageCoordsToSeadragonCoords(midpoint.toSeadragonPoint(), viewer);
	    }
	}
	function pinchEventHandler(scaleDeltaX, scaleDeltaY, scaleDeltaXY, touch1, touch2, event) {
		//alert("pinchEventHandler")
	    // clamp the zoom scale delta to within [0.8, 1.2]
	    scaleDeltaXY = Math.max(0.8, Math.min(1.2, scaleDeltaXY));
	    if (viewer.isOpen() && viewer.viewport && pinchMidpoint !== null) {
	      	viewer.viewport.zoomBy(scaleDeltaXY, pinchMidpoint);
	      	// clamp the zoom level to [viewer.viewport.getMinZoom(), viewer.viewport.getMaxZoom()]
	      	if (viewer.viewport.getZoom() > viewer.viewport.getMaxZoom()) {
	         	viewer.viewport.zoomTo(viewer.viewport.getMaxZoom(), pinchMidpoint);
	      	}
	      	else if (viewer.viewport.getZoom() < viewer.viewport.getMinZoom()) {
	         	viewer.viewport.zoomTo(viewer.viewport.getMinZoom(), pinchMidpoint);
	      	}
	   	}
	}
	function resizeCanvas (e) {

		// todo: record current giga Point and size around that

		// var p = new Seadragon.Point( viewer.viewport.getHomeCenter() )
		// console.log("The center point before resize = " + p)

		// todo: this should be smoother (doesn't seem to align with top of the window)

		if (viewer) {
			wv  = document.documentElement.clientWidth
			hv  = document.documentElement.clientHeight
			zoom = zoom_init * hv * wgp / (wv * hgp)
			viewer.viewport.zoomTo(zoom, pointofinterest, true)
		}
	}

	// *************************************************
	// END Gigapan integration
	// *************************************************

}])

mainApp.controller('watchshowController', [
        '$scope', '$sce', 'defService',
function($scope ,  $sce ,  defService){

	var vm = this

	vm.shows = [ 
	{
		"title": "Origins",
		"cove_id": 2365568806,
		"caption": "See how powerful geological forces sculpted North America"
	},
	{
		"title": "Life",
		"cove_id": 2365584086,
		"caption": "Discover how a changing North American landscape shaped life"
	},
	{
		"title": "Human",
		"cove_id": 2365589618,
		"caption": "Learn how the North American continent impacted human life"
	},
	]
	vm.tour = {
		"title": "Google Earth Tour",
		"cove_id": 2365302438,
		"caption": "Lorem Ipsum super awesome Google Earth Fly-through everything Unicorn Tour"
	}
	vm.showvid = false
	vm.cove_iframe = false
	vm.locked = defService.locked()
	
	vm.playVideo = function(cove_id) {
		vm.showvid = true
		vm.cove_iframe = $sce.trustAsHtml( constructVideoDiv(cove_id, true, 2*1080, 2*608) )
	}

	vm.endMedia = function() {
		logit("close me")
	 	vm.showvid = false
	 	vm.cove_iframe = "" // kill the video
	}

	$scope.$on("$destroy", function() {
		logit("destroy the watch controller")
		vm.cove_iframe = ""
    });

}]);

// animation

mainApp.animation('.slide-animation', function() {
    return {
        beforeAddClass: function(element, classname, done) {
            var scope = element.scope(),
                duration = 500
            if (classname == 'ng-hide') {
                // do the out anim
                
                var finishPoint = element.parent().width();

                if (scope.$parent.expstop.slide_direction == 'left') {
                    finishPoint = -finishPoint;
                }
                TweenMax.to(element, 0.75, {left: finishPoint, onComplete: done });

               
                //element.animate({'left':finishPoint }, duration, function() {done()}) 

            } else {
                done()
            }
        }, removeClass: function (element, classname, done) {
            var scope = element.scope(),
                duration = 500
            if (classname == 'ng-hide') {
                element.removeClass('ng-hide')
                logit('do the in anim' + element.name)
                // do the in anim
                var startPoint = element.parent().width();
                if(scope.$parent.expstop.slide_direction === 'right') {
                    startPoint = -startPoint;
                }

                //element.css({'left':startPoint })
                //element.animate({'left':0 }, duration, function() {done()}) 

                TweenMax.set(element, { left: startPoint });
                TweenMax.to(element, 0.75, {left: 0, onComplete: done });

                                

            } else {
                done()
            }
        }
    }
    // animation code adapted from: http://onehungrymind.com/build-sweet-photo-slider-angularjs-animate/
})


// todo: put this into a directive
function constructVideoDiv(coveid, autoplay,w,h) {
	// return the html code for the player, based on passed vars
	var src = 'http://video.pbs.org/widget/partnerplayer/'+coveid+'/?w='+w+'&h='+h+'&chapterbar=true&autoplay='+autoplay+'&endscreen=false',
		code = '<iframe id="partnerPlayer" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" style="width:100%" src="'+src+'"></iframe>'
	return code
}





